import { AppInfo, Call, CallsRequest, CallsResponse, DatabaseInfo, SessionInfo } from '@/types/analytics';

export const analytics = (
  baseUrl: string,
  fetchWithAuth: (url: string, options?: RequestInit) => Promise<Response>
) => {
  return {
    callList: async (callsRequest: CallsRequest): Promise<CallsResponse | undefined> => {
      const url = new URL(`${baseUrl}/Calls`);

      const params = new URLSearchParams();
      callsRequest.startDateTime &&
        params.append('startDateTime', callsRequest.startDateTime.format('YYYY-MM-DD HH:mm:ss.SSS'));
      callsRequest.endDateTime &&
        params.append('endDateTime', callsRequest.endDateTime.add(1, 'minute').format('YYYY-MM-DD HH:mm:ss.SSS'));
      callsRequest.page && params.append('page', callsRequest.page.toString());
      params.append('search', callsRequest.search);
      params.append('itemsperPage', '50');
      url.search = params.toString();

      const response = await fetchWithAuth(url.toString());

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const text = await response.text();
      if (!text) {
        return;
      }

      const data = JSON.parse(text);
      console.debug('Get call list response', data);
      return data;
    },

    call: async (uuid: string): Promise<Call | undefined> => {
      const url = new URL(`${baseUrl}/Calls/${uuid}`);

      const response = await fetchWithAuth(url.toString());

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const text = await response.text();
      if (!text) {
        return;
      }

      const data = JSON.parse(text);
      console.debug('Get call response', data);
      return data;
    },

    traces: async (uuid: string): Promise<SessionInfo | undefined> => {
      const url = new URL(`${baseUrl}/Traces/${uuid}`);

      const response = await fetchWithAuth(url.toString());

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const text = await response.text();
      if (!text) {
        return;
      }

      const data = JSON.parse(text);
      console.debug('Get traces response', data);
      return data;
    },

    appLogs: async (uuid: string): Promise<AppInfo | undefined> => {
      const url = new URL(`${baseUrl}/AppLogs/${uuid}`);

      const response = await fetchWithAuth(url.toString());

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const text = await response.text();
      if (!text) {
        return;
      }

      const data = JSON.parse(text);
      console.debug('Get app logs response', data);
      return data;
    },

    databaseLogs: async (uuid: string): Promise<DatabaseInfo | undefined> => {
      const url = new URL(`${baseUrl}/DbLogs/${uuid}`);
      const response = await fetchWithAuth(url.toString());

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const text = await response.text();
      if (!text) {
        return;
      }

      const data = JSON.parse(text);
      console.debug('Get database logs response', data);
      return data;
    }
  };
};
